
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Shop',
    showFilters: 'Filters',
    categoriesShowAll: 'Show all',
    categoriesHide: 'Hide',
    from: 'from',
    noItemsFound: 'No items found',
    purchaseSuccessful: 'Purchase successful!',
    errorLoadItems: 'Failed to load items',
    errorPurchase: 'Failed to purchase item',
    categoriesAll: 'All',
    categoriesRifles: 'Rifles',
    categoriesPistols: 'Pistols',
    categoriesSmgs: 'SMGs',
    categoriesHeavy: 'Heavy',
    categoriesKnives: 'Knives',
    categoriesGloves: 'Gloves',
    categoriesEquipment: 'Equipment',
    categoriesOther: 'Other',
    categoriesCases: 'Cases',
    categoriesKeychains: 'Keychains',
    categoriesGraffiti: 'Graffiti',
    categoriesStickers: 'Stickers',
    categoriesAgents: 'Agents',
    filtersCategory: 'Category',
    filtersWeapon: 'Weapon',
    filtersType: 'Type',
    filtersWear: 'Wear',
    filtersRarity: 'Rarity',
    filtersAllRarities: 'All Rarities',
    filtersPriceRange: 'Price Range',
    filtersMinPrice: 'Minimum',
    filtersMaxPrice: 'Maximum',
    filtersStatTrak: 'StatTrak™',
    filtersSortBy: 'Sort By',
    filtersSortByVolume: 'By Popularity',
    filtersSortByPriceAsc: 'Price: Low to High',
    filtersSortByPriceDesc: 'Price: High to Low',
    filtersSortByCountDesc: 'Count: High to Low',
    filtersSortByCountAsc: 'Count: Low to High',
    filtersReset: 'Reset',
    filtersApply: 'Apply',
    typesAll: 'All',
    typesSkin: 'Skin',
    typesCrate: 'Crate',
    typesKeychain: 'Keychain',
    typesGraffiti: 'Graffiti',
    typesSticker: 'Sticker',
    typesAgent: 'Agent',
    wearAll: 'All',
    wearFactoryNew: 'Factory New',
    wearMinimalWear: 'Minimal Wear',
    wearFieldTested: 'Field-Tested',
    wearWellWorn: 'Well-Worn',
    wearBattleScarred: 'Battle-Scarred',
    itemNotFound: 'Item not found',
    itemPrice: 'Price',
    itemBuy: 'Buy',
    itemInsufficientBalance: 'Insufficient balance',
    itemYourBalance: 'Your balance',
    itemPurchaseError: 'Failed to purchase item',
    itemPurchaseSuccess: 'Item purchased successfully!',
    itemPaymentSettingsError: 'Failed to load payment settings',
    itemPaymentNotReady: 'Payment settings not loaded. Please try again later',
    confirmBuyTitle: 'Confirm Purchase',
    confirmBuyMessage: 'Are you sure you want to buy {{item}} for {{price}}?',
    confirmBuyCancel: 'Cancel',
    confirmBuyConfirm: 'Buy',
    errorLoadSkins: 'Failed to load skins',
    noSkinsFound: 'No skins found',
  },
  ru: {
    title: 'Магазин',
    showFilters: 'Фильтры',
    categoriesShowAll: 'Показать все',
    categoriesHide: 'Скрыть',
    from: 'от',
    noItemsFound: 'Предметы не найдены',
    purchaseSuccessful: 'Покупка успешна!',
    errorLoadItems: 'Не удалось загрузить предметы',
    errorPurchase: 'Не удалось купить предмет',
    categoriesAll: 'Все',
    categoriesRifles: 'Винтовки',
    categoriesPistols: 'Пистолеты',
    categoriesSmgs: 'ПП',
    categoriesHeavy: 'Тяжёлое',
    categoriesKnives: 'Ножи',
    categoriesGloves: 'Перчатки',
    categoriesEquipment: 'Снаряжение',
    categoriesOther: 'Другое',
    categoriesCases: 'Кейсы',
    categoriesKeychains: 'Брелоки',
    categoriesGraffiti: 'Граффити',
    categoriesStickers: 'Стикеры',
    categoriesAgents: 'Агенты',
    filtersCategory: 'Категория',
    filtersWeapon: 'Оружие',
    filtersType: 'Тип',
    filtersWear: 'Износ',
    filtersRarity: 'Редкость',
    filtersAllRarities: 'Все редкости',
    filtersPriceRange: 'Диапазон цен',
    filtersMinPrice: 'Минимум',
    filtersMaxPrice: 'Максимум',
    filtersStatTrak: 'StatTrak™',
    filtersSortBy: 'Сортировать',
    filtersSortByVolume: 'По популярности',
    filtersSortByPriceAsc: 'Сначала дешевые',
    filtersSortByPriceDesc: 'Сначала дорогие',
    filtersSortByCountDesc: 'По количеству (убыв.)',
    filtersSortByCountAsc: 'По количеству (возр.)',
    filtersReset: 'Сбросить',
    filtersApply: 'Применить',
    typesAll: 'Все',
    typesSkin: 'Скин',
    typesCrate: 'Кейс',
    typesKeychain: 'Брелок',
    typesGraffiti: 'Граффити',
    typesSticker: 'Наклейка',
    typesAgent: 'Агент',
    wearAll: 'Все',
    wearFactoryNew: 'Прямо с завода',
    wearMinimalWear: 'Немного поношенное',
    wearFieldTested: 'После полевых испытаний',
    wearWellWorn: 'Поношенное',
    wearBattleScarred: 'Закалённое в боях',
    itemNotFound: 'Предмет не найден',
    itemPrice: 'Цена',
    itemBuy: 'Купить',
    itemInsufficientBalance: 'Недостаточно средств',
    itemYourBalance: 'Твой баланс',
    itemPurchaseError: 'Не удалось купить предмет',
    itemPurchaseSuccess: 'Предмет успешно куплен!',
    itemPaymentSettingsError: 'Не удалось загрузить настройки оплаты',
    itemPaymentNotReady: 'Настройки оплаты не загружены. Попробуй позже',
    confirmBuyTitle: 'Подтверждение покупки',
    confirmBuyMessage: 'Ты уверен, что хочешь купить {{item}} за {{price}}?',
    confirmBuyCancel: 'Отмена',
    confirmBuyConfirm: 'Купить',
    errorLoadSkins: 'Не удалось загрузить скины',
    noSkinsFound: 'Скины не найдены',
  },
  uz: {
    title: 'Doʻkon',
    showFilters: 'Filtrlar',
    categoriesShowAll: 'Barchasini koʻrsatish',
    categoriesHide: 'Yashirish',
    from: 'dan',
    noItemsFound: 'Buyumlar topilmadi',
    purchaseSuccessful: 'Xarid muvaffaqiyatli!',
    errorLoadItems: 'Buyumlarni yuklash amalga oshmadi',
    errorPurchase: 'Buyumni sotib olish amalga oshmadi',
    categoriesAll: 'Hammasi',
    categoriesRifles: 'Miltiqlar',
    categoriesPistols: 'Toʻpponchalar',
    categoriesSmgs: 'Avtomatlar',
    categoriesHeavy: 'Ogʻir',
    categoriesKnives: 'Pichoqlar',
    categoriesGloves: 'Qoʻlqoplar',
    categoriesEquipment: 'Jihozlar',
    categoriesOther: 'Boshqa',
    categoriesCases: 'Keyslar',
    categoriesKeychains: 'Breloklar',
    categoriesGraffiti: 'Graffiti',
    categoriesStickers: 'Stikerlar',
    categoriesAgents: 'Agentlar',
    filtersCategory: 'Kategoriya',
    filtersWeapon: 'Qurol',
    filtersType: 'Turi',
    filtersWear: 'Holati',
    filtersRarity: 'Kamyoblik',
    filtersAllRarities: 'Barcha kamyobliklar',
    filtersPriceRange: 'Narx oraligʻi',
    filtersMinPrice: 'Minimum',
    filtersMaxPrice: 'Maksimum',
    filtersStatTrak: 'StatTrak™',
    filtersSortBy: 'Saralash',
    filtersSortByVolume: 'Mashhurlik boʻyicha',
    filtersSortByPriceAsc: 'Arzonroqdan qimmatga',
    filtersSortByPriceDesc: 'Qimmatroqdan arzonga',
    filtersSortByCountDesc: 'Soni boʻyicha (kam.)',
    filtersSortByCountAsc: 'Soni boʻyicha (koʻp.)',
    filtersReset: 'Tozalash',
    filtersApply: 'Qoʻllash',
    typesAll: 'Hammasi',
    typesSkin: 'Skin',
    typesCrate: 'Keys',
    typesKeychain: 'Kalitcha',
    typesGraffiti: 'Graffiti',
    typesSticker: 'Stiker',
    typesAgent: 'Agent',
    wearAll: 'Hammasi',
    wearFactoryNew: 'Zavod yangi',
    wearMinimalWear: 'Minimal eskirgan',
    wearFieldTested: 'Maydonda sinovdan oʻtgan',
    wearWellWorn: 'Yaxshi eskirgan',
    wearBattleScarred: 'Jangda zararlangan',
    itemNotFound: 'Buyum topilmadi',
    itemPrice: 'Narx',
    itemBuy: 'Sotib olish',
    itemInsufficientBalance: 'Mablagʻ yetarli emas',
    itemYourBalance: 'Balansing',
    itemPurchaseError: 'Buyumni sotib olish amalga oshmadi',
    itemPurchaseSuccess: 'Buyum muvaffaqiyatli sotib olindi!',
    itemPaymentSettingsError: 'Toʻlov sozlamalarini yuklab boʻlmadi',
    itemPaymentNotReady: 'Toʻlov sozlamalari yuklanmagan. Keyinroq qayta urinib koʻr',
    confirmBuyTitle: 'Xaridni tasdiqlash',
    confirmBuyMessage: '{{item}} ni {{price}} ga sotib olmoqchimisan?',
    confirmBuyCancel: 'Bekor qilish',
    confirmBuyConfirm: 'Sotib olish',
    errorLoadSkins: 'Skinlarni yuklab boʻlmadi',
    noSkinsFound: 'Skinlar topilmadi',
  },
  fa: {
    title: 'فروشگاه',
    showFilters: 'فیلترها',
    categoriesShowAll: 'دیدن همه',
    categoriesHide: 'بستن',
    from: 'از',
    noItemsFound: 'آیتمی پیدا نشد',
    purchaseSuccessful: 'خرید انجام شد!',
    errorLoadItems: 'آیتم‌ها بارگذاری نشدند',
    errorPurchase: 'آیتم خریداری نشد',
    categoriesAll: 'همه',
    categoriesRifles: 'رایفل',
    categoriesPistols: 'پیستول',
    categoriesSmgs: 'اس‌ام‌جی',
    categoriesHeavy: 'سنگین',
    categoriesKnives: 'چاقو',
    categoriesGloves: 'دستکش',
    categoriesEquipment: 'تجهیزات',
    categoriesOther: 'سایر',
    categoriesCases: 'کیس‌ها',
    categoriesKeychains: 'آویز',
    categoriesGraffiti: 'گرافیتی',
    categoriesStickers: 'استیکر',
    categoriesAgents: 'ایجنت',
    filtersCategory: 'دسته',
    filtersWeapon: 'سلاح',
    filtersType: 'نوع',
    filtersWear: 'فرسودگی',
    filtersRarity: 'کمیابی',
    filtersAllRarities: 'همه کمیابی‌ها',
    filtersPriceRange: 'بازه قیمت',
    filtersMinPrice: 'کمینه',
    filtersMaxPrice: 'بیشینه',
    filtersStatTrak: 'StatTrak™',
    filtersSortBy: 'مرتب‌سازی',
    filtersSortByVolume: 'بر پایه محبوبیت',
    filtersSortByPriceAsc: 'قیمت: کم به زیاد',
    filtersSortByPriceDesc: 'قیمت: زیاد به کم',
    filtersSortByCountDesc: 'تعداد: زیاد به کم',
    filtersSortByCountAsc: 'تعداد: کم به زیاد',
    filtersReset: 'پاک کن',
    filtersApply: 'اعمال کن',
    typesAll: 'همه',
    typesSkin: 'اسکین',
    typesCrate: 'جعبه',
    typesKeychain: 'آویز',
    typesGraffiti: 'گرافیتی',
    typesSticker: 'استیکر',
    typesAgent: 'ایجنت',
    wearAll: 'همه',
    wearFactoryNew: 'Factory New',
    wearMinimalWear: 'Minimal Wear',
    wearFieldTested: 'Field-Tested',
    wearWellWorn: 'Well-Worn',
    wearBattleScarred: 'Battle-Scarred',
    itemNotFound: 'آیتم پیدا نشد',
    itemPrice: 'قیمت',
    itemBuy: 'بخر',
    itemInsufficientBalance: 'موجودی کافی نیست',
    itemYourBalance: 'موجودی تو',
    itemPurchaseError: 'آیتم خریداری نشد',
    itemPurchaseSuccess: 'آیتم خریداری شد!',
    itemPaymentSettingsError: 'تنظیمات پرداخت بارگذاری نشد',
    itemPaymentNotReady: 'تنظیمات پرداخت بارگذاری نشده. بعداً تلاش کن',
    confirmBuyTitle: 'تأیید خرید',
    confirmBuyMessage: 'مطمئنی {{item}} را به {{price}} می‌خری؟',
    confirmBuyCancel: 'بی‌خیال',
    confirmBuyConfirm: 'بخر',
    errorLoadSkins: 'اسکین‌ها بارگذاری نشدند',
    noSkinsFound: 'اسکینی پیدا نشد',
  },
  pt: {
    title: 'Loja',
    showFilters: 'Filtros',
    categoriesShowAll: 'Mostrar todas',
    categoriesHide: 'Ocultar',
    from: 'a partir de',
    noItemsFound: 'Nenhum item encontrado',
    purchaseSuccessful: 'Compra concluída!',
    errorLoadItems: 'Não foi possível carregar os itens',
    errorPurchase: 'Não foi possível comprar o item',
    categoriesAll: 'Todas',
    categoriesRifles: 'Rifles',
    categoriesPistols: 'Pistolas',
    categoriesSmgs: 'SMGs',
    categoriesHeavy: 'Pesadas',
    categoriesKnives: 'Facas',
    categoriesGloves: 'Luvas',
    categoriesEquipment: 'Equipamento',
    categoriesOther: 'Outros',
    categoriesCases: 'Caixas',
    categoriesKeychains: 'Chaveiros',
    categoriesGraffiti: 'Grafites',
    categoriesStickers: 'Adesivos',
    categoriesAgents: 'Agentes',
    filtersCategory: 'Categoria',
    filtersWeapon: 'Arma',
    filtersType: 'Tipo',
    filtersWear: 'Desgaste',
    filtersRarity: 'Raridade',
    filtersAllRarities: 'Todas as raridades',
    filtersPriceRange: 'Faixa de preço',
    filtersMinPrice: 'Mínimo',
    filtersMaxPrice: 'Máximo',
    filtersStatTrak: 'StatTrak™',
    filtersSortBy: 'Ordenar',
    filtersSortByVolume: 'Por popularidade',
    filtersSortByPriceAsc: 'Mais baratos primeiro',
    filtersSortByPriceDesc: 'Mais caros primeiro',
    filtersSortByCountDesc: 'Por quantidade (decresc.)',
    filtersSortByCountAsc: 'Por quantidade (cresc.)',
    filtersReset: 'Limpar',
    filtersApply: 'Aplicar',
    typesAll: 'Todos',
    typesSkin: 'Skin',
    typesCrate: 'Caixa',
    typesKeychain: 'Chaveiro',
    typesGraffiti: 'Grafite',
    typesSticker: 'Adesivo',
    typesAgent: 'Agente',
    wearAll: 'Todos',
    wearFactoryNew: 'Nova de Fábrica',
    wearMinimalWear: 'Pouco Usada',
    wearFieldTested: 'Testada em Campo',
    wearWellWorn: 'Bem Desgastada',
    wearBattleScarred: 'Veterana de Guerra',
    itemNotFound: 'Item não encontrado',
    itemPrice: 'Preço',
    itemBuy: 'Comprar',
    itemInsufficientBalance: 'Saldo insuficiente',
    itemYourBalance: 'Seu saldo',
    itemPurchaseError: 'Não foi possível comprar o item',
    itemPurchaseSuccess: 'Item comprado com sucesso!',
    itemPaymentSettingsError: 'Não foi possível carregar as configurações de pagamento',
    itemPaymentNotReady: 'As configurações de pagamento não foram carregadas. Tente mais tarde',
    confirmBuyTitle: 'Confirmar compra',
    confirmBuyMessage: 'Tem certeza de que quer comprar {{item}} por {{price}}?',
    confirmBuyCancel: 'Cancelar',
    confirmBuyConfirm: 'Comprar',
    errorLoadSkins: 'Não foi possível carregar as skins',
    noSkinsFound: 'Nenhuma skin encontrada',
  },
  tr: {
    title: 'Mağaza',
    showFilters: 'Filtreler',
    categoriesShowAll: 'Tümünü göster',
    categoriesHide: 'Gizle',
    from: 'en az',
    noItemsFound: 'Eşya bulunamadı',
    purchaseSuccessful: 'Satın alma başarılı!',
    errorLoadItems: 'Eşyalar yüklenemedi',
    errorPurchase: 'Eşya satın alınamadı',
    categoriesAll: 'Tümü',
    categoriesRifles: 'Tüfekler',
    categoriesPistols: 'Tabancalar',
    categoriesSmgs: 'SMG',
    categoriesHeavy: 'Ağır silahlar',
    categoriesKnives: 'Bıçaklar',
    categoriesGloves: 'Eldivenler',
    categoriesEquipment: 'Ekipman',
    categoriesOther: 'Diğer',
    categoriesCases: 'Kasalar',
    categoriesKeychains: 'Anahtarlıklar',
    categoriesGraffiti: 'Grafiti',
    categoriesStickers: 'Çıkartmalar',
    categoriesAgents: 'Ajanlar',
    filtersCategory: 'Kategori',
    filtersWeapon: 'Silah',
    filtersType: 'Tür',
    filtersWear: 'Aşınma',
    filtersRarity: 'Nadirlik',
    filtersAllRarities: 'Tüm nadirlikler',
    filtersPriceRange: 'Fiyat aralığı',
    filtersMinPrice: 'Minimum',
    filtersMaxPrice: 'Maksimum',
    filtersStatTrak: 'StatTrak™',
    filtersSortBy: 'Sırala',
    filtersSortByVolume: 'Popülerliğe göre',
    filtersSortByPriceAsc: 'Önce ucuzlar',
    filtersSortByPriceDesc: 'Önce pahalılar',
    filtersSortByCountDesc: 'Adede göre (azalan)',
    filtersSortByCountAsc: 'Adede göre (artan)',
    filtersReset: 'Sıfırla',
    filtersApply: 'Uygula',
    typesAll: 'Tümü',
    typesSkin: 'Skin',
    typesCrate: 'Kasa',
    typesKeychain: 'Anahtarlık',
    typesGraffiti: 'Grafiti',
    typesSticker: 'Çıkartma',
    typesAgent: 'Ajan',
    wearAll: 'Tümü',
    wearFactoryNew: 'Fabrikadan Yeni Çıkmış',
    wearMinimalWear: 'Az Aşınmış',
    wearFieldTested: 'Sahada Test Edilmiş',
    wearWellWorn: 'Çok Aşınmış',
    wearBattleScarred: 'Savaşta Yıpranmış',
    itemNotFound: 'Eşya bulunamadı',
    itemPrice: 'Fiyat',
    itemBuy: 'Satın al',
    itemInsufficientBalance: 'Yetersiz bakiye',
    itemYourBalance: 'Bakiyen',
    itemPurchaseError: 'Eşya satın alınamadı',
    itemPurchaseSuccess: 'Eşya başarıyla satın alındı!',
    itemPaymentSettingsError: 'Ödeme ayarları yüklenemedi',
    itemPaymentNotReady: 'Ödeme ayarları yüklenmedi. Daha sonra tekrar dene',
    confirmBuyTitle: 'Satın almayı onayla',
    confirmBuyMessage: '{{item}} eşyasını {{price}} karşılığında satın almak istediğine emin misin?',
    confirmBuyCancel: 'İptal',
    confirmBuyConfirm: 'Satın al',
    errorLoadSkins: 'Skinler yüklenemedi',
    noSkinsFound: 'Skin bulunamadı',
  },
});
